import SMConst from 'frontend_core/dist/constants/sm-const'
import Path from 'routes/path'
import { type State as ReservationDetailState } from 'redux/modules/reservationDetail'
import { getReservationChangeRequestBlockProps } from 'components/molecules/ReservationChangeRequestBlock/presenter'
import { getReservationGetPointBlockProps } from 'components/molecules/ReservationGetPointBlock/presenter'
import { getReservationAdditionalFeeBlockProps } from 'components/molecules/ReservationAdditionalFeeBlock/presenter'

export function getReservationChangeGuestFormProps(
  reservationDetail: ReservationDetailState,
  onClickBackToMessage: Function,
) {
  const { detail } = reservationDetail
  const unapproved = detail.unapproved_reservation_from_user || {}
  const reservationChangeRequestBlockProps = getReservationChangeRequestBlockProps(
    detail,
    unapproved,
  )
  return {
    reservationChangeRequestBlockProps,
    reservationGetPointBlockProps: getReservationGetPointBlockProps(
      detail,
      unapproved,
    ),
    reservationAdditionalFeeBlockProps: getReservationAdditionalFeeBlockProps(
      detail,
      reservationChangeRequestBlockProps.billStatementProps.additionalFee,
      unapproved,
    ),
    onClickBackToMessage,
  }
}



// WEBPACK FOOTER //
// ./src/components/organisms/ReservationChangeGuestForm/presenter.js